import { useEffect, useState } from 'react';
import InputSearch from 'src/components/atoms/InputSearch';
import {
  useAction,
  useFilterSettingsStore,
  useLabels,
  useWindowWidthStore,
} from 'src/StoreDataProvider';
import Filter from '../Filter/Filter';

const FilterSection: () => JSX.Element = () => {
  const { setShowFilter } = useAction();
  const labels = useLabels();
  const { searchTerm } = useFilterSettingsStore();
  const windowState = useWindowWidthStore();
  const [isOpen, setIsOpen] = useState(false);
  const [tempSearchTerm, setTempSearchTerm] = useState(searchTerm);
  const { setFiltersSearchTerm } = useAction();

  useEffect(() => {
    if (!windowState.isMobileView) {
      setShowFilter(false);
    } else {
      setShowFilter(isOpen);
    }
  }, [isOpen, windowState.isMobileView]);

  useEffect(() => {
    if (!windowState.isMobileView) {
      setIsOpen(false);
    }
  }, [windowState.isMobileView]);

  useEffect(() => {
    setTempSearchTerm(searchTerm);
  }, [searchTerm]);

  return (
    <section id="filters" className="col-auto">
      {windowState.isMobileView && isOpen && (
        <section id="closeFilters" className="col-auto">
          <div className="navigate__filter__box">
            <button
              className="navigate navigate__back"
              onClick={() => setIsOpen(false)}
            >
              <em className="icon-pfeil-links" aria-hidden="true" />
              <span>{labels.backToSearchResults}</span>
            </button>
          </div>
        </section>
      )}
      <div className="filter-card">
        <InputSearch
          id="searchProject"
          label={labels.searchProject}
          onChange={value => {
            setTempSearchTerm(value);
          }}
          onBlur={() => {
            if (searchTerm !== tempSearchTerm)
              setFiltersSearchTerm(tempSearchTerm);
          }}
          onClear={() => {
            setFiltersSearchTerm('');
            if (tempSearchTerm !== '') {
              setTempSearchTerm('');
            }
          }}
          onSearch={() => {
            if (searchTerm !== tempSearchTerm)
              setFiltersSearchTerm(tempSearchTerm);
          }}
          value={tempSearchTerm}
        />
      </div>

      {windowState.isMobileView && !isOpen && (
        <div id="filter-show" className="filter-card filter-show ">
          <button aria-expanded="false" onClick={() => setIsOpen(true)}>
            <em className="icon-plus" />
            <div>{labels.showFilter}</div>
          </button>
        </div>
      )}
      <Filter
        id="filter"
        showFilter={isOpen}
        setShowFilter={setIsOpen}
      ></Filter>
    </section>
  );
};

export default FilterSection;
